// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"616bf766","823":"d42f4c56"}[chunkId] + ".css";
};